define('plugin/package/view/PackageIntemBaseView',['require','lib/view/LayoutView','lib/model/package/PackageDataInflator'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Inflator = require('lib/model/package/PackageDataInflator');

    /**
     * Package item base view
     *
     * @class PackageItemBaseView
     */
    return LayoutView.extend({

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);

            return this._attachInfo(data);
        },

        _attachInfo: function (data) {
            var inflator = new Inflator({
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection')
            });

            return inflator.attachObjectData(data);
        }

    });

});
